// @ts-nocheck
import { IconWrapper } from "@insite/mobius/Icon";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import getPreviousBreakpoint from "@toolkit/Framework/Common/Utilities/getPreviousBreakpoint";
import { focusStyles, iconColorStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

export const headerMobileSelector = () => css`
    ${({ theme }) => breakpoint(getPreviousBreakpoint(theme.design.header.breakpoint, theme), "down")}
`;

export const headerDesktopSelector = () => css`
    ${({ theme }) => breakpoint(theme.design.header.breakpoint)}
`;

export const headerHideForDesktopStyles = () => css`
    ${headerDesktopSelector()} {
        display: none;
    }
`;

export const headerHideForMobileStyles = () => css`
    ${headerMobileSelector()} {
        display: none;
    }
`;

export const headerIconStyles = () => {
    const transition = transitionHoverStyles("color");

    return css`
        ${focusStyles(true)}
        ${x => breakpointValues(x.theme.design.header.iconButton.padding, "padding")}
        transition: ${transition};

        ${IconWrapper} {
            ${iconColorStyles("header", transition)}/* Store Custom Code */
        }

        &:hover,
        &:active,
        &[aria-expanded="true"] {
            ${IconWrapper} {
                /* Store Custom Code - Start */
                ${iconColorStyles("header.hover", transition)}
                /* stylelint-disable-next-line CssSyntaxError */
                filter: drop-shadow(0 4px 8px rgba(13, 10, 44, 0.30));
                /* Store Custom Code - End */
            }
        }
    `;
};
